<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import Swal from '@/utils/ugm-swal';

export default {
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: "Historial de Digitalizacion",
            items: [
                { text: "Digitalizar", href: "/" },
                { text: "Historial", active: true }
            ],
            historial: [],
            loading: false,
            search: '',
            historialCompleto: false,
            loadingRestoHistorial: false,
            historialLoadId: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            itemSeleccionado: null,
            itemSeleccionadoNumero: null,
            editandoPagina: {},
            guardandoPagina: {},
            autoSaveTimers: {},
            guardadoPendiente: {},
            guardadoPromesas: {},
            firmasGuardadas: {},
            refrescandoResultado: {},
            syncingHubspotContacto: {},
            syncingHubspotBulk: false,
            colegios: [],
            cargandoColegios: false,
            listaCursos: [
                '1° medio',
                '2° medio',
                '3° medio',
                '4° medio',
                'Egresado',
            ],
            listaCarreras: [
                'Arquitectura',
                'Diseño de Videojuegos',
                'Diseño de Animación Digital',
                'Diseño en Interacción Digital',
                'Diseño en Marketing Digital',
                'Derecho',
                'Ingeniería Civil Industrial',
                'Ingeniería Civil Informática',
                'Ingeniería Comercial',
                'Psicología',
                'Licenciatura en Filosofia',
                'Licenciatura en Historia',
                'Licenciatura en Literatura',
            ],
        };
    },
    computed: {
        filteredData() {
            const q = this.search.toLowerCase();
            if (!q) return this.historial;
            return this.historial.filter(item =>
                (item.nombreEvento || '').toLowerCase().includes(q) ||
                (item.usuario || '').toLowerCase().includes(q) ||
                (item.tipo || '').toLowerCase().includes(q) ||
                String(item.id).includes(q)
            );
        },
        rows() { return this.filteredData.length; },
        paginatedData() {
            const s = (this.currentPage - 1) * this.perPage;
            return this.filteredData.slice(s, s + this.perPage);
        },
        puedeBorrarHistorial() {
            return Number(this.user?.id) === 1;
        },
    },
    methods: {
        async fetchHistorial(colegiosPromise = Promise.resolve()) {
            const loadId = ++this.historialLoadId;
            this.loading = true;
            this.loadingRestoHistorial = false;
            try {
                const response = await axios.get('/api/get_asociados', {
                    params: {
                        limit: this.historialCompleto ? 0 : 10,
                        offset: 0,
                        summary: 1,
                    },
                });
                await colegiosPromise;
                if (loadId !== this.historialLoadId) return;

                this.historial = (response.data.asociados || [])
                    .map((asociado) => this.mapHistorialAsociado(asociado))
                    .sort((a, b) => this.timestampHistorial(b.fechaOrden) - this.timestampHistorial(a.fechaOrden));
                this.firmasGuardadas = {};
                this.loading = false;

                if (!this.historialCompleto && response.data.pagination?.has_more) {
                    this.cargarRestoHistorial(loadId);
                }
            } catch (error) {
                if (loadId !== this.historialLoadId) return;
                this.msg?.('danger', error.response?.data?.message || 'No se pudo cargar el historial de digitalización.');
            } finally {
                if (loadId === this.historialLoadId) {
                    this.loading = false;
                }
            }
        },
        mapHistorialAsociado(a) {
            const nombreArchivo = a.nombre_archivo || `evento_${a.evento?.codigo || a.evento_id}.pdf`;
            const extension = (nombreArchivo.split('.').pop() || '').toUpperCase();

            return {
                id: a.id,
                eventoId: a.evento_id,
                laboranteId: a.laborante_id,
                nombreEvento: a.evento?.nombre_difusion || a.evento?.codigo || '-',
                hubspotActividadId: a.evento?.hubspot_actividad_id || '',
                hubspotEventoSincronizado: !!a.evento?.hubspot_actividad_id,
                eventoRbdColegio: a.evento?.rbd_colegio || '',
                eventoColegio: a.evento?.colegio || '',
                filename: nombreArchivo,
                numeroPaginas: a.total_imagenes || 0,
                fichasVerificadas: a.fichas_verificadas || 0,
                totalFichasVerificacion: a.total_fichas_verificacion || a.total_imagenes || 0,
                archivosVerificacion: a.archivos_verificacion || [],
                tipo: extension || 'ARCHIVO',
                estado: a.estado_verificacion || a.alegoria_estado || this.estadoDesdeConteos(a),
                fechaOrden: a.ultima_subida_at || a.created_at || a.updated_at || '',
                fecha: this.formatearFechaHistorial(a.ultima_subida_at || a.created_at),
                usuario: a.laborante?.name || '-',
                alegoria: {
                    enviadas: a.alegoria_enviadas || 0,
                    completadas: a.alegoria_completadas || 0,
                    revision: a.alegoria_necesitan_revision || 0,
                    fallidas: a.alegoria_fallidas || 0,
                },
                datosOCR: null,
                detallesCargados: false,
                cargandoDetalle: false,
            };
        },
        async cargarRestoHistorial(loadId) {
            this.loadingRestoHistorial = true;
            try {
                const response = await axios.get('/api/get_asociados', {
                    params: {
                        limit: 90,
                        offset: 10,
                        summary: 1,
                    },
                });
                if (loadId !== this.historialLoadId) return;

                this.historial = this.historial.concat(
                    (response.data.asociados || []).map((asociado) => this.mapHistorialAsociado(asociado))
                ).sort((a, b) => this.timestampHistorial(b.fechaOrden) - this.timestampHistorial(a.fechaOrden));
            } catch (error) {
                if (loadId === this.historialLoadId) {
                    this.msg?.('danger', error.response?.data?.message || 'No se pudieron cargar los demás registros del historial.');
                }
            } finally {
                if (loadId === this.historialLoadId) {
                    this.loadingRestoHistorial = false;
                }
            }
        },
        cambiarModoHistorial() {
            this.historialCompleto = !this.historialCompleto;
            this.currentPage = 1;
            this.fetchHistorial();
        },
        estadoDesdeConteos(a) {
            if ((a.alegoria_fallidas || 0) > 0) return 'error';
            if ((a.alegoria_necesitan_revision || 0) > 0) return 'revision';
            if ((a.alegoria_completadas || 0) >= (a.total_imagenes || 0) && (a.total_imagenes || 0) > 0) return 'completado';
            if ((a.alegoria_enviadas || 0) > 0) return 'procesando';
            if (a.imagenes_digitalizadas >= a.total_imagenes && a.total_imagenes > 0) return 'completado';
            return 'pendiente';
        },
        formatearFechaHistorial(value) {
            if (!value) return '-';

            const fecha = new Date(value);
            if (Number.isNaN(fecha.getTime())) {
                return String(value);
            }

            const dia = String(fecha.getDate()).padStart(2, '0');
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const anio = fecha.getFullYear();

            return `${dia}/${mes}/${anio}`;
        },
        timestampHistorial(value) {
            if (!value) return 0;

            const fecha = new Date(value);
            return Number.isNaN(fecha.getTime()) ? 0 : fecha.getTime();
        },
        recalcularEstadoItemSeleccionado() {
            const item = this.itemSeleccionado;
            if (!item) return;

            const items = item.datosOCR?.items || [];
            if (!items.length) {
                item.estado = 'pendiente';
                return;
            }

            const hasFailed = items.some(entry => entry?.status === 'failed');
            if (hasFailed) {
                item.estado = 'error';
                return;
            }

            const verified = items.filter(entry => this.fichaVerificada(entry)).length;
            item.fichasVerificadas = verified;
            item.totalFichasVerificacion = items.length;
            if (verified === items.length) {
                item.estado = 'finalizado';
                return;
            }

            const hasReview = items.some(entry => entry?.status === 'needs_review' || (entry?.reviewReasons || []).length > 0);
            if (hasReview) {
                item.estado = 'revision';
                return;
            }

            const allCompleted = items.every(entry => ['completed', 'stored_for_review', 'needs_review'].includes(String(entry?.status || '').trim())
                || ['ActualizadoAWS', 'Revisada'].includes(String(entry?.tipoMime || entry?.tipo_mime || '').trim()));
            if (allCompleted) {
                item.estado = 'revision';
                return;
            }

            const hasSent = items.some(entry => String(entry?.requestId || '').trim() !== '');
            item.estado = hasSent ? 'procesando' : 'pendiente';
        },
        estadoVariant(estado) {
            if (estado === 'finalizado' || estado === 'completado') return 'success';
            if (estado === 'procesando') return 'warning';
            if (estado === 'revision') return 'info';
            if (estado === 'error') return 'danger';
            return 'secondary';
        },
        diasVariant(dias) {
            if (dias <= 7) return 'danger';
            if (dias <= 15) return 'warning';
            return 'success';
        },
        hubspotVariant(sincronizado) {
            return sincronizado ? 'success' : 'warning';
        },
        hubspotButtonVariant(ocr) {
            const status = String(ocr?.hubspotSyncStatus || '').trim().toLowerCase();
            if (status === 'error') {
                return 'danger';
            }
            if (this.hubspotTieneCambiosPendientes(ocr)) {
                return 'warning';
            }

            return 'outline-info';
        },
        hubspotButtonLabel(ocr) {
            if (String(ocr?.hubspotSyncStatus || '').trim().toLowerCase() === 'error') {
                return 'Reintentar envio a HubSpot';
            }
            if (this.hubspotTieneCambiosPendientes(ocr)) {
                return 'Enviar cambios a HubSpot';
            }

            return ocr.hubspotSynced ? 'Actualizar HubSpot' : 'Enviar a HubSpot';
        },
        hubspotTieneCambiosPendientes(ocr) {
            const status = String(ocr?.hubspotSyncStatus || '').trim().toLowerCase();
            return ['pending', 'error'].includes(status) || !!ocr?.hubspotSyncPending;
        },
        async cargarColegios() {
            this.cargandoColegios = true;

            try {
                const response = await axios.get('/api/get_colegios');
                const colegios = response.data?.colegios || [];

                this.colegios = colegios
                    .filter(colegio => String(colegio?.rbd ?? '').trim() !== '' && String(colegio.rbd) !== '0')
                    .filter(colegio => String(colegio?.nombre ?? '').trim() !== '')
                    .map(colegio => ({
                        id: colegio.id,
                        rbd: colegio.rbd,
                        nombre: colegio.nombre,
                        hubspot_company_id: colegio.hubspot_company_id || '',
                    }))
                    .sort((a, b) => String(a.nombre).localeCompare(String(b.nombre), 'es'));
            } catch (error) {
                this.colegios = [];
            } finally {
                this.cargandoColegios = false;
            }
        },
        colegioLabel(colegio) {
            if (!colegio) return '';
            return `${colegio.nombre || ''} - RBD ${colegio.rbd || ''}`;
        },
        colegioPorIdentificador(fields = {}) {
            const colegioId = String(fields.colegio_id || '').trim();
            const rbd = String(fields.rbd_colegio || '').trim();

            return this.colegios.find(colegio => colegioId !== '' && String(colegio.id) === colegioId)
                || this.colegios.find(colegio => rbd !== '' && String(colegio.rbd) === rbd)
                || null;
        },
        normalizeCursoValue(value) {
            const actual = String(value || '')
                .trim()
                .toLowerCase()
                .replace(/\s+/g, ' ');

            if (actual === '') {
                return '';
            }

            const mapa = {
                '1': '1° medio',
                '1°': '1° medio',
                '1º': '1° medio',
                '1 medio': '1° medio',
                '1° medio': '1° medio',
                '1º medio': '1° medio',
                'primero medio': '1° medio',
                '2': '2° medio',
                '2°': '2° medio',
                '2º': '2° medio',
                '2 medio': '2° medio',
                '2° medio': '2° medio',
                '2º medio': '2° medio',
                'segundo medio': '2° medio',
                '3': '3° medio',
                '3°': '3° medio',
                '3º': '3° medio',
                '3 medio': '3° medio',
                '3° medio': '3° medio',
                '3º medio': '3° medio',
                'tercero medio': '3° medio',
                '4': '4° medio',
                '4°': '4° medio',
                '4º': '4° medio',
                '4 medio': '4° medio',
                '4° medio': '4° medio',
                '4º medio': '4° medio',
                'cuarto medio': '4° medio',
                'egresado': 'Egresado',
                'egresados': 'Egresado',
            };

            return mapa[actual] || String(value || '').trim();
        },
        seleccionarColegio(colegio, idx) {
            const ocr = this.itemSeleccionado?.datosOCR?.items?.[idx];
            if (!ocr?.fields) return;

            this.$set(ocr, 'colegioSeleccionado', colegio || null);
            this.$set(ocr.fields, 'colegio_id', colegio ? colegio.id : '');
            this.$set(ocr.fields, 'colegio', colegio ? String(colegio.nombre || '') : '');
            this.$set(ocr.fields, 'rbd_colegio', colegio ? String(colegio.rbd || '') : '');
            this.programarAutoGuardado(idx, true);
        },
        totalContactosHubspotPendientes() {
            const items = this.itemSeleccionado?.datosOCR?.items || [];
            return items.filter((ocr) => ocr?.id).length;
        },
        cursoOptionsFor(valorActual) {
            const actual = this.normalizeCursoValue(valorActual);
            const options = this.listaCursos.map(curso => ({ value: curso, text: curso }));

            if (actual !== '' && !this.listaCursos.includes(actual)) {
                options.unshift({ value: actual, text: actual });
            }

            return [{ value: null, text: 'Sin seleccion' }, ...options];
        },
        normalizeCarreraValue(value) {
            const actual = String(value || '').trim();

            if (actual === '') {
                return '';
            }

            const comparable = (candidate) => String(candidate || '')
                .trim()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();
            const canonical = this.listaCarreras.find(carrera => comparable(carrera) === comparable(actual));

            return canonical || '';
        },
        carreraOptionsFor() {
            const options = this.listaCarreras.map(carrera => ({ value: carrera, text: carrera }));

            return [{ value: null, text: 'Sin seleccion' }, ...options];
        },
        normalizeRutValue(value) {
            return String(value || '')
                .toUpperCase()
                .replace(/[.,\s]/g, '')
                .replace(/[^0-9K-]/g, '')
                .trim();
        },
        documentFlagValue(value) {
            if (typeof value === 'boolean') {
                return value;
            }

            return ['1', 'true', 'yes', 'si', 'sí', 'on'].includes(String(value || '').trim().toLowerCase());
        },
        normalizePassportValue(value) {
            return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
        },
        formatRutValue(value) {
            const limpio = String(value || '')
                .toUpperCase()
                .replace(/[^0-9K]/g, '');

            if (limpio === '') {
                return '';
            }

            if (limpio.length <= 1) {
                return limpio;
            }

            const dv = limpio.slice(-1);
            const cuerpo = limpio.slice(0, -1);
            const cuerpoFormateado = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

            return `${cuerpoFormateado}-${dv}`;
        },
        onRutInput(ocr) {
            if (!ocr?.fields) {
                return;
            }

            if (ocr.fields.sin_rut) {
                ocr.fields.rut = '';
                return;
            }

            ocr.fields.rut = ocr.fields.es_pasaporte
                ? this.normalizePassportValue(ocr.fields.rut)
                : this.formatRutValue(ocr.fields.rut);
        },
        cambiarEstadoDocumento(ocr, tipo, idx) {
            if (!ocr?.fields) {
                return;
            }

            if (tipo === 'sin_rut' && ocr.fields.sin_rut) {
                this.$set(ocr.fields, 'es_pasaporte', false);
                this.$set(ocr.fields, 'rut', '');
            } else if (tipo === 'es_pasaporte' && ocr.fields.es_pasaporte) {
                this.$set(ocr.fields, 'sin_rut', false);
                this.$set(ocr.fields, 'rut', this.normalizePassportValue(ocr.fields.rut));
            } else if (tipo === 'es_pasaporte') {
                this.$set(ocr.fields, 'rut', this.formatRutValue(ocr.fields.rut));
            }

            this.programarAutoGuardado(idx, true);
        },
        isValidRut(value) {
            const normalizado = this.normalizeRutValue(value);
            if (normalizado === '') {
                return true;
            }

            const limpio = normalizado.replace(/-/g, '');
            if (!/^\d{7,9}[\dK]$/.test(limpio)) {
                return false;
            }

            const dv = limpio.slice(-1);
            const cuerpo = limpio.slice(0, -1);
            if (!/^\d{7,9}$/.test(cuerpo)) {
                return false;
            }

            let suma = 0;
            let multiplo = 2;

            for (let i = cuerpo.length - 1; i >= 0; i -= 1) {
                suma += parseInt(cuerpo.charAt(i), 10) * multiplo;
                multiplo = multiplo === 7 ? 2 : multiplo + 1;
            }

            const resto = 11 - (suma % 11);
            const esperado = resto === 11 ? '0' : resto === 10 ? 'K' : String(resto);
            return esperado === dv;
        },
        isValidEmail(value) {
            const email = String(value || '').trim();
            if (email === '') {
                return true;
            }

            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        },
        rutInputClass(ocr) {
            return {
                'is-invalid': !ocr.fields?.es_pasaporte && !ocr.fields?.sin_rut && !this.isValidRut(ocr.fields?.rut),
            };
        },
        emailInputClass(ocr) {
            return {
                'is-invalid': !this.isValidEmail(ocr.fields?.email),
            };
        },
        documentoVerificable(fields = {}) {
            if (fields.sin_rut) return true;
            if (fields.es_pasaporte) return this.normalizePassportValue(fields.rut).length > 0;
            return String(fields.rut || '').trim() !== '' && this.isValidRut(fields.rut);
        },
        motivosFichaPendiente(ocr = {}) {
            const fields = ocr.fields || {};
            const missing = [];
            if (!String(fields.nombres || '').trim()) missing.push('nombre');
            if (!String(fields.apellido_paterno || '').trim()) missing.push('apellido paterno');
            if (!this.documentoVerificable(fields)) missing.push('RUT válido, pasaporte o marca Sin RUT');
            if (!String(fields.colegio || '').trim()) missing.push('colegio');
            if (!String(fields.curso || '').trim()) missing.push('curso');
            if (!fields.acepta_terminos) missing.push('aceptación de términos y condiciones');
            if (!ocr.hubspotSynced || this.hubspotTieneCambiosPendientes(ocr)) missing.push('envío actualizado a HubSpot');
            return missing;
        },
        fichaVerificada(ocr) {
            return this.motivosFichaPendiente(ocr).length === 0;
        },
        archivoFinalizado(ocr) {
            const items = this.itemSeleccionado?.datosOCR?.items || [];
            const fileKey = `${ocr?.requestId || ''}|${ocr?.fileName || ''}`;
            const fichasArchivo = items.filter(item => `${item?.requestId || ''}|${item?.fileName || ''}` === fileKey);
            return fichasArchivo.length > 0 && fichasArchivo.every(item => this.fichaVerificada(item));
        },
        enrichImagenesWithFileContext(imagenes) {
            const fileNumbers = new Map();
            const pageCounters = new Map();
            const previewIds = new Map();

            return imagenes.map((img) => {
                const fileName = img.nombre_original || 'archivo-sin-nombre';
                const fileKey = `${img.alegoria_request_id || ''}|${fileName}`;

                if (!fileNumbers.has(fileKey)) {
                    fileNumbers.set(fileKey, fileNumbers.size + 1);
                    previewIds.set(fileKey, img.id);
                }

                const sourcePage = Array.isArray(img.source_pages) && img.source_pages.length ? Number(img.source_pages[0]) : 0;
                const itemIndexPage = Number.isInteger(img.alegoria_item_index) ? img.alegoria_item_index + 1 : 0;
                const fallbackPage = (pageCounters.get(fileKey) || 0) + 1;
                const pageInFile = sourcePage || itemIndexPage || fallbackPage;

                pageCounters.set(fileKey, Math.max(pageCounters.get(fileKey) || 0, pageInFile));

                return {
                    ...img,
                    fileName,
                    fileNumber: fileNumbers.get(fileKey),
                    pageInFile,
                    previewId: previewIds.get(fileKey),
                };
            });
        },
        mapImagenToOcr(img, index, evento = {}) {
            const fields = img.fields || {};
            const sinRut = this.documentFlagValue(fields.sin_rut);
            const esPasaporte = !sinRut && this.documentFlagValue(fields.es_pasaporte);
            const colegioNombre = fields.establecimiento || evento?.colegio || '';
            const rbdColegio = fields.rbd_colegio || evento?.rbd_colegio || '';
            const colegioSeleccionado = this.colegioPorIdentificador({
                colegio_id: fields.colegio_id || '',
                rbd_colegio: rbdColegio,
            });
            const rawCareer = String(fields.carrera || '').trim();
            const preferencia1 = this.normalizeCarreraValue(fields.preferencia_1)
                || this.normalizeCarreraValue(fields.marca_1)
                || this.normalizeCarreraValue(rawCareer);
            const preferencia2 = this.normalizeCarreraValue(fields.preferencia_2)
                || this.normalizeCarreraValue(fields.marca_2);
            const preferencia3 = this.normalizeCarreraValue(fields.preferencia_3)
                || this.normalizeCarreraValue(fields.marca_3);
            const preferenciaExtraExplicita = String(fields.preferencia_extra || fields.preferencia_3_otra || fields.asignatura_extra || fields.opcion_adicional || '').trim();
            let preferenciaExtra = preferenciaExtraExplicita;
            let preferenciaExtra2 = String(fields.preferencia_extra_2 || fields.preferencia_2_otra || '').trim();

            if (rawCareer !== '' && this.normalizeCarreraValue(rawCareer) === '') {
                if (preferenciaExtra === ''
                    && (preferenciaExtra2 === '' || preferenciaExtra2.toLowerCase() !== rawCareer.toLowerCase())) {
                    preferenciaExtra = rawCareer;
                } else if (preferenciaExtra !== '' && preferenciaExtra2 === ''
                    && preferenciaExtra.toLowerCase() !== rawCareer.toLowerCase()) {
                    preferenciaExtra2 = rawCareer;
                }
            }

            return {
                page: index + 1,
                fileName: img.fileName || img.nombre_original || '',
                fileNumber: img.fileNumber || 1,
                pageInFile: img.pageInFile || index + 1,
                eventoId: evento?.id || this.itemSeleccionado?.eventoId || null,
                id: img.id,
                status: img.alegoria_status,
                tipoMime: img.tipo_mime || '',
                requestId: img.alegoria_request_id,
                processedAt: img.alegoria_processed_at,
                url: img.previewId || img.id
                    ? `/api/imagenes_digitalizadas/${img.previewId || img.id}/preview#page=${img.pageInFile || index + 1}&view=FitH&pagemode=none&navpanes=0&toolbar=0`
                    : (img.url_publica || img.alegoria_url_img),
                reviewReasons: img.review_reasons || [],
                hubspotContactId: img.hubspot_contact_id || '',
                hubspotSyncHash: img.hubspot_sync_hash || '',
                hubspotSyncStatus: img.hubspot_sync_status || (img.hubspot_contact_id ? 'synced' : 'not_synced'),
                hubspotSyncError: img.hubspot_sync_error || '',
                hubspotSyncAction: img.hubspot_sync_action || '',
                hubspotSyncPending: !!img.hubspot_sync_pending,
                hubspotSynced: (img.hubspot_sync_status || (img.hubspot_contact_id ? 'synced' : 'not_synced')) === 'synced' && !!img.hubspot_contact_id,
                hubspotFuente: img.hubspot_fuente || '',
                hubspotSyncedAt: img.hubspot_synced_at || '',
                verification: img.verification || null,
                colegioSeleccionado,
                fields: {
                    name: fields.nombre_completo || '',
                    nombres: fields.nombres || '',
                    apellido_paterno: fields.apellido_paterno || '',
                    apellido_materno: fields.apellido_materno || '',
                    rut: sinRut ? '' : (esPasaporte
                        ? this.normalizePassportValue(fields.rut || '')
                        : this.formatRutValue(fields.rut || '')),
                    fecha: fields.fecha || '',
                    es_pasaporte: esPasaporte,
                    sin_rut: sinRut,
                    email: fields.email || '',
                    phone: fields.celular || '',
                    colegio: colegioSeleccionado?.nombre || colegioNombre,
                    colegio_id: colegioSeleccionado?.id || '',
                    rbd_colegio: colegioSeleccionado?.rbd || rbdColegio,
                    curso: this.normalizeCursoValue(fields.curso || ''),
                    carrera: preferencia1,
                    preferencia_2: preferencia2,
                    preferencia_3: preferencia3,
                    preferencia_extra: preferenciaExtra,
                    preferencia_extra_2: preferenciaExtra2,
                    acepta_terminos: ['si', 'sí', 's', 'yes', 'true', '1'].includes(String(fields.acepta_terminos || '').trim().toLowerCase()),
                }
            };
        },
        async verDetalle(item) {
            this.itemSeleccionado = item;
            this.itemSeleccionadoNumero = this.filteredData.indexOf(item) + 1;
            this.editandoPagina = {};
            this.$nextTick(() => this.$refs['modal-detalle'].show());

            if (item.detallesCargados || item.cargandoDetalle) {
                return;
            }

            this.$set(item, 'cargandoDetalle', true);
            try {
                const response = await axios.get('/api/get_asociados', {
                    params: {
                        evento_id: item.eventoId,
                        laborante_id: item.laboranteId,
                    },
                });
                const asociado = (response.data.asociados || []).find((row) =>
                    String(row.evento_id) === String(item.eventoId)
                    && String(row.laborante_id) === String(item.laboranteId)
                );
                const imagenes = (asociado?.imagenes || []).filter((img) => img.tipo_mime !== 'PlantillaAsistente');
                item.datosOCR = imagenes.length ? {
                    items: this.enrichImagenesWithFileContext(imagenes)
                        .map((img, index) => this.mapImagenToOcr(img, index, asociado?.evento || {})),
                } : null;
                item.detallesCargados = true;

                (item.datosOCR?.items || []).forEach((ocr) => {
                    if (ocr?.id) {
                        this.$set(ocr, 'eventoId', item.eventoId);
                        this.$set(this.firmasGuardadas, ocr.id, this.firmaPayloadGuardado(ocr));
                    }
                });
                this.recalcularEstadoItemSeleccionado();
            } catch (error) {
                this.msg?.('danger', error.response?.data?.message || 'No se pudieron cargar los detalles del registro.');
            } finally {
                this.$set(item, 'cargandoDetalle', false);
            }
        },
        clearAutoSaveTimer(ocrId) {
            if (!ocrId || !this.autoSaveTimers[ocrId]) {
                return;
            }

            clearTimeout(this.autoSaveTimers[ocrId]);
            this.$delete(this.autoSaveTimers, ocrId);
        },
        construirPayloadGuardado(ocr) {
            const fields = ocr?.fields || {};
            const nombres = String(fields.nombres || '').trim();
            const apellidoPaterno = String(fields.apellido_paterno || '').trim();
            const apellidoMaterno = String(fields.apellido_materno || '').trim();
            const sinRut = !!fields.sin_rut;
            const esPasaporte = !sinRut && !!fields.es_pasaporte;
            const documento = sinRut
                ? ''
                : (esPasaporte
                    ? this.normalizePassportValue(fields.rut)
                    : this.formatRutValue(fields.rut || ''));

            return {
                id_imagen: ocr?.id,
                evento_id: ocr?.eventoId || this.itemSeleccionado?.eventoId || null,
                nombre_completo: [nombres, apellidoPaterno, apellidoMaterno].filter(Boolean).join(' '),
                nombres,
                apellido_paterno: apellidoPaterno,
                apellido_materno: apellidoMaterno,
                rut: documento,
                es_pasaporte: esPasaporte,
                sin_rut: sinRut,
                fecha: String(fields.fecha || ''),
                curso: this.normalizeCursoValue(fields.curso || ''),
                email: String(fields.email || ''),
                celular: String(fields.phone || ''),
                nombre_colegio: String(fields.colegio || ''),
                rbd_colegio: String(fields.rbd_colegio || ''),
                colegio_id: fields.colegio_id || '',
                carrera: this.normalizeCarreraValue(fields.carrera || ''),
                preferencia_2: this.normalizeCarreraValue(fields.preferencia_2 || ''),
                preferencia_3: this.normalizeCarreraValue(fields.preferencia_3 || ''),
                preferencia_3_otra: String(fields.preferencia_extra || ''),
                preferencia_2_otra: String(fields.preferencia_extra_2 || ''),
                acepta_terminos: !!fields.acepta_terminos,
            };
        },
        firmaPayloadGuardado(ocr) {
            return JSON.stringify(this.construirPayloadGuardado(ocr));
        },
        flushAutoGuardado() {
            const items = this.itemSeleccionado?.datosOCR?.items || [];
            const promesas = [];

            items.forEach((ocr, idx) => {
                if (!ocr?.id) {
                    return;
                }

                if (this.autoSaveTimers[ocr.id]) {
                    this.clearAutoSaveTimer(ocr.id);
                    promesas.push(this.guardarCambios(idx, true));
                } else if (this.guardandoPagina[ocr.id] && this.guardadoPromesas[ocr.id]) {
                    promesas.push(this.guardadoPromesas[ocr.id]);
                }
            });

            return Promise.all(promesas);
        },
        async esperarGuardadoAntesDeHubspot(ocr) {
            const ocrId = ocr?.id;
            if (!ocrId) {
                return { ok: false, message: 'Contacto digitalizado no encontrado.' };
            }

            this.clearAutoSaveTimer(ocrId);

            for (let intento = 0; intento < 4; intento += 1) {
                const itemsActuales = this.itemSeleccionado?.datosOCR?.items || [];
                const idx = itemsActuales.findIndex(item => String(item?.id) === String(ocrId));
                const ocrActual = idx >= 0 ? itemsActuales[idx] : null;
                if (!ocrActual?.id) {
                    return { ok: false, message: 'Contacto digitalizado no encontrado.' };
                }

                if (this.guardandoPagina[ocrId] && this.guardadoPromesas[ocrId]) {
                    const resultadoEnCurso = await this.guardadoPromesas[ocrId];
                    if (!resultadoEnCurso?.ok) {
                        return resultadoEnCurso;
                    }
                }

                const itemsDespuesDeGuardar = this.itemSeleccionado?.datosOCR?.items || [];
                const idxDespuesDeGuardar = itemsDespuesDeGuardar.findIndex(item => String(item?.id) === String(ocrId));
                const ocrDespuesDeGuardar = idxDespuesDeGuardar >= 0
                    ? itemsDespuesDeGuardar[idxDespuesDeGuardar]
                    : ocrActual;
                const firmaActual = this.firmaPayloadGuardado(ocrDespuesDeGuardar);
                const firmaGuardada = this.firmasGuardadas[ocrId];
                const requiereGuardado = !!this.guardadoPendiente[ocrId]
                    || !firmaGuardada
                    || firmaActual !== firmaGuardada;

                if (!requiereGuardado) {
                    return { ok: true };
                }

                const resultado = await this.guardarCambios(idx, true);
                if (!resultado?.ok) {
                    return resultado || { ok: false, message: 'No se pudieron guardar los cambios.' };
                }
            }

            return { ok: false, message: 'El guardado del contacto todavía está en curso. Intenta nuevamente.' };
        },
        programarAutoGuardado(idx, immediate = false) {
            const ocr = this.itemSeleccionado?.datosOCR?.items?.[idx];
            if (!ocr?.id) return;

            this.clearAutoSaveTimer(ocr.id);

            const executeSave = () => {
                this.guardarCambios(idx, true);
            };

            if (immediate) {
                executeSave();
                return;
            }

            const timeoutId = setTimeout(() => {
                this.$delete(this.autoSaveTimers, ocr.id);
                executeSave();
            }, 700);

            this.$set(this.autoSaveTimers, ocr.id, timeoutId);
        },
        async refrescarResultado(ocr, idx) {
            if (!ocr?.id) return;

            this.$set(this.refrescandoResultado, ocr.id, true);

            try {
                const response = await axios.post(`/api/alegoria-docapi/imagenes/${ocr.id}/refresh`);
                const imagen = response.data?.imagen;
                const imagenes = response.data?.imagenes || [];
                const imagenesVisibles = imagenes.filter(img => img.tipo_mime !== 'PlantillaAsistente');

                if (imagenesVisibles.length && this.itemSeleccionado?.datosOCR) {
                    this.itemSeleccionado.datosOCR.items = this.enrichImagenesWithFileContext(imagenesVisibles).map((img, index) => this.mapImagenToOcr(img, index, {
                        rbd_colegio: this.itemSeleccionado?.eventoRbdColegio || '',
                        colegio: this.itemSeleccionado?.eventoColegio || '',
                    }));
                    this.itemSeleccionado.numeroPaginas = response.data?.pages || imagenesVisibles.length;
                    this.recalcularEstadoItemSeleccionado();
                } else if (imagen && imagen.tipo_mime !== 'PlantillaAsistente' && this.itemSeleccionado?.datosOCR?.items) {
                    const actualizado = this.mapImagenToOcr(imagen, idx, {
                        rbd_colegio: this.itemSeleccionado?.eventoRbdColegio || '',
                        colegio: this.itemSeleccionado?.eventoColegio || '',
                    });
                    this.$set(this.itemSeleccionado.datosOCR.items, idx, actualizado);
                    this.recalcularEstadoItemSeleccionado();
                }

                this.msg?.('success', response.data?.message || 'Resultado actualizado desde AlegoriaDocAPI.');
            } catch (error) {
                const message = error.response?.data?.message || 'No se pudo consultar el resultado en AlegoriaDocAPI.';
                this.msg?.('danger', message);
            } finally {
                this.$set(this.refrescandoResultado, ocr.id, false);
            }
        },
        aplicarEstadoHubspot(ocr, data = {}, success = false) {
            if (!ocr) return;

            if (Object.prototype.hasOwnProperty.call(data, 'hubspot_contact_id')) {
                this.$set(ocr, 'hubspotContactId', data.hubspot_contact_id || '');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'hubspot_sync_hash')) {
                this.$set(ocr, 'hubspotSyncHash', data.hubspot_sync_hash || '');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'hubspot_sync_status')) {
                this.$set(ocr, 'hubspotSyncStatus', data.hubspot_sync_status || '');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'hubspot_sync_error')) {
                this.$set(ocr, 'hubspotSyncError', data.hubspot_sync_error || '');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'hubspot_sync_action')) {
                this.$set(ocr, 'hubspotSyncAction', data.hubspot_sync_action || '');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'hubspot_sync_pending')) {
                this.$set(ocr, 'hubspotSyncPending', !!data.hubspot_sync_pending);
            }
            if (Object.prototype.hasOwnProperty.call(data, 'synced_at')) {
                this.$set(ocr, 'hubspotSyncedAt', data.synced_at || '');
            }
            if (success && data.estado === true) {
                this.$set(ocr, 'hubspotSynced', String(data.hubspot_sync_status || 'synced') === 'synced' && !!ocr.hubspotContactId);
                this.$set(ocr, 'hubspotFuente', 'hubspot');
            } else if (Object.prototype.hasOwnProperty.call(data, 'hubspot_sync_status')) {
                this.$set(ocr, 'hubspotSynced', data.hubspot_sync_status === 'synced' && !!ocr.hubspotContactId);
            }
            this.recalcularEstadoItemSeleccionado();
        },
        async syncContactoHubspotRequest(ocr, silent = false) {
            if (!ocr?.id || !this.itemSeleccionado?.hubspotActividadId) {
                if (!silent) {
                    this.msg?.('warning', 'El evento aun no esta sincronizado con HubSpot.');
                }
                return { ok: false, skipped: true };
            }

            const guardado = await this.esperarGuardadoAntesDeHubspot(ocr);
            if (!guardado?.ok) {
                const message = guardado?.message || 'No se pudieron guardar los cambios antes de sincronizar.';
                if (!silent) {
                    this.msg?.('danger', message);
                }
                return { ok: false, message };
            }

            const ocrActual = (this.itemSeleccionado?.datosOCR?.items || [])
                .find(item => String(item?.id) === String(ocr.id)) || ocr;
            this.$set(this.syncingHubspotContacto, ocr.id, true);

            try {
                const response = await axios.post(`/api/imagenes_digitalizadas/${ocr.id}/sync-hubspot`);
                const data = response.data || {};

                if (data.estado !== true || !String(data.hubspot_contact_id || '').trim()) {
                    const message = data.message || 'HubSpot no confirmó la sincronización del contacto.';
                    this.aplicarEstadoHubspot(ocrActual, {
                        ...data,
                        hubspot_sync_status: data.hubspot_sync_status || 'error',
                        hubspot_sync_error: data.hubspot_sync_error || message,
                        hubspot_sync_pending: true,
                    });
                    if (!silent) {
                        this.msg?.('danger', message);
                    }
                    return { ok: false, message, data };
                }

                this.aplicarEstadoHubspot(ocrActual, data, true);

                if (data.hubspot_actividad_id) {
                    this.itemSeleccionado.hubspotActividadId = data.hubspot_actividad_id;
                    this.itemSeleccionado.hubspotEventoSincronizado = true;
                }

                if (!silent) {
                    this.msg?.('success', data.message || 'Contacto sincronizado correctamente con HubSpot.');
                }
                return { ok: true, data };
            } catch (error) {
                const message = error.response?.data?.message || 'No se pudo sincronizar el contacto con HubSpot.';
                this.aplicarEstadoHubspot(ocrActual, {
                    ...(error.response?.data || {}),
                    hubspot_sync_status: error.response?.data?.hubspot_sync_status || 'error',
                    hubspot_sync_error: error.response?.data?.hubspot_sync_error || message,
                    hubspot_sync_pending: true,
                });
                if (!silent) {
                    this.msg?.('danger', message);
                }
                return { ok: false, message };
            } finally {
                this.$set(this.syncingHubspotContacto, ocr.id, false);
            }
        },
        async syncContactoHubspot(ocr) {
            await this.syncContactoHubspotRequest(ocr, false);
        },
        async syncTodosContactosHubspot() {
            if (!this.itemSeleccionado?.hubspotEventoSincronizado) {
                this.msg?.('warning', 'El evento aun no esta sincronizado con HubSpot.');
                return;
            }

            const items = (this.itemSeleccionado?.datosOCR?.items || []).filter((ocr) => ocr?.id);
            if (!items.length) {
                this.msg?.('warning', 'No hay contactos para enviar a HubSpot.');
                return;
            }

            const confirm = await Swal.fire({
                icon: 'question',
                title: 'Enviar todos a HubSpot',
                text: `Se enviaran ${items.length} contactos del documento a HubSpot.`,
                showCancelButton: true,
                confirmButtonText: 'Enviar todos',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#252C5F',
            });

            if (!confirm.isConfirmed) {
                return;
            }

            this.syncingHubspotBulk = true;

            Swal.fire({
                title: 'Enviando contactos...',
                html: `Procesando 0 de ${items.length} contactos.`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => Swal.showLoading(),
            });

            let exitosos = 0;
            let fallidos = 0;

            for (let index = 0; index < items.length; index += 1) {
                const ocr = items[index];
                Swal.update({
                    html: `Procesando ${index + 1} de ${items.length} contactos.`,
                });

                const result = await this.syncContactoHubspotRequest(ocr, true);
                if (result.ok) {
                    exitosos += 1;
                } else if (!result.skipped) {
                    fallidos += 1;
                }
            }

            this.syncingHubspotBulk = false;

            Swal.fire({
                icon: fallidos > 0 ? 'warning' : 'success',
                title: fallidos > 0 ? 'Envio completado con observaciones' : 'Contactos enviados a HubSpot',
                html: `
                    <div style="text-align:left;">
                        <p class="mb-1"><strong>Enviados:</strong> ${exitosos}</p>
                        <p class="mb-0"><strong>Fallidos:</strong> ${fallidos}</p>
                    </div>
                `,
            });
        },
        async guardarCambios(i, silent = false) {
            const ocr = this.itemSeleccionado?.datosOCR?.items?.[i];
            if (!ocr?.id) {
                return { ok: false, message: 'Imagen digitalizada no encontrada.' };
            }

            this.clearAutoSaveTimer(ocr.id);

            if (this.guardandoPagina[ocr.id]) {
                this.$set(this.guardadoPendiente, ocr.id, true);
                return this.guardadoPromesas[ocr.id] || Promise.resolve({
                    ok: false,
                    pending: true,
                    message: 'El guardado del contacto todavía está en curso.',
                });
            }

            this.$set(this.guardandoPagina, ocr.id, true);

            const savePromise = (async () => {
                try {
                    for (let intento = 0; intento < 8; intento += 1) {
                        const itemsActuales = this.itemSeleccionado?.datosOCR?.items || [];
                        const indiceActual = itemsActuales.findIndex(item => String(item?.id) === String(ocr.id));
                        const ocrActual = indiceActual >= 0 ? itemsActuales[indiceActual] : null;

                        if (!ocrActual?.id) {
                            return { ok: false, message: 'Imagen digitalizada no encontrada.' };
                        }

                        const payload = this.construirPayloadGuardado(ocrActual);
                        const firmaEnviada = JSON.stringify(payload);
                        this.$delete(this.guardadoPendiente, ocr.id);

                        let response;
                        try {
                            response = await axios.post('/api/actualizar_imagen_revisada', payload);
                        } catch (error) {
                            const message = error.response?.data?.message || 'No se pudieron guardar los cambios.';
                            if (!silent) {
                                this.msg?.('danger', message);
                            }
                            return { ok: false, message };
                        }

                        const itemsDespues = this.itemSeleccionado?.datosOCR?.items || [];
                        const indiceDespues = itemsDespues.findIndex(item => String(item?.id) === String(ocr.id));
                        const itemDespues = indiceDespues >= 0 ? itemsDespues[indiceDespues] : null;
                        const cambiosDuranteGuardado = !itemDespues
                            || this.firmaPayloadGuardado(itemDespues) !== firmaEnviada;
                        const imagen = response.data?.imagen;

                        if (imagen && itemDespues && indiceDespues >= 0) {
                            const actualizado = this.mapImagenToOcr(imagen, indiceDespues, {
                                id: this.itemSeleccionado?.eventoId,
                                rbd_colegio: this.itemSeleccionado?.eventoRbdColegio || '',
                                colegio: this.itemSeleccionado?.eventoColegio || '',
                            });
                            const itemActualizado = {
                                ...itemDespues,
                                ...actualizado,
                                fileName: itemDespues.fileName,
                                fileNumber: itemDespues.fileNumber,
                                pageInFile: itemDespues.pageInFile,
                                url: itemDespues.url,
                                hubspotContactId: actualizado.hubspotContactId || itemDespues.hubspotContactId,
                                hubspotSynced: actualizado.hubspotSyncStatus
                                    ? actualizado.hubspotSyncStatus === 'synced' && !!(actualizado.hubspotContactId || itemDespues.hubspotContactId)
                                    : itemDespues.hubspotSynced,
                                hubspotFuente: actualizado.hubspotFuente || itemDespues.hubspotFuente,
                                hubspotSyncStatus: actualizado.hubspotSyncStatus || itemDespues.hubspotSyncStatus,
                                hubspotSyncError: actualizado.hubspotSyncError || '',
                                hubspotSyncAction: actualizado.hubspotSyncAction || itemDespues.hubspotSyncAction,
                                hubspotSyncHash: actualizado.hubspotSyncHash || itemDespues.hubspotSyncHash,
                                hubspotSyncPending: typeof actualizado.hubspotSyncPending === 'boolean'
                                    ? actualizado.hubspotSyncPending
                                    : itemDespues.hubspotSyncPending,
                                hubspotSyncedAt: actualizado.hubspotSyncedAt || itemDespues.hubspotSyncedAt,
                                fields: cambiosDuranteGuardado
                                    ? { ...itemDespues.fields }
                                    : { ...itemDespues.fields, ...actualizado.fields },
                                colegioSeleccionado: cambiosDuranteGuardado
                                    ? itemDespues.colegioSeleccionado
                                    : actualizado.colegioSeleccionado,
                            };
                            this.$set(this.itemSeleccionado.datosOCR.items, indiceDespues, itemActualizado);
                        }

                        if (cambiosDuranteGuardado) {
                            this.$set(this.guardadoPendiente, ocr.id, true);
                            continue;
                        }

                        const itemGuardado = this.itemSeleccionado?.datosOCR?.items?.[indiceDespues]
                            || this.itemSeleccionado?.datosOCR?.items?.[i]
                            || ocrActual;
                        this.recalcularEstadoItemSeleccionado();
                        this.$delete(this.guardadoPendiente, ocr.id);
                        this.$set(this.firmasGuardadas, ocr.id, this.firmaPayloadGuardado(itemGuardado));

                        if (!silent) {
                            this.msg?.('success', response.data?.message || 'Datos guardados correctamente.');
                        }
                        return { ok: true, data: response.data };
                    }

                    return {
                        ok: false,
                        message: 'El contacto sigue cambiando mientras se guarda. Intenta nuevamente.',
                    };
                } catch (error) {
                    const message = error.response?.data?.message || 'No se pudieron guardar los cambios.';
                    if (!silent) {
                        this.msg?.('danger', message);
                    }
                    return { ok: false, message };
                } finally {
                    this.$set(this.guardandoPagina, ocr.id, false);
                    this.$delete(this.guardadoPromesas, ocr.id);
                }
            })();

            this.$set(this.guardadoPromesas, ocr.id, savePromise);
            return savePromise;
        },
        descargar(item) {
            const url = item.datosOCR?.items?.[0]?.url;
            if (url) window.open(url, '_blank');
        },
        async eliminarHistorial(item) {
            const confirm = await Swal.fire({
                icon: 'warning',
                title: 'Borrar digitalizacion existente',
                text: `Se eliminaran las paginas existentes del evento ${item.nombreEvento}.`,
                showCancelButton: true,
                confirmButtonText: 'Borrar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#dc3545',
            });

            if (!confirm.isConfirmed) return;

            try {
                const response = await axios.post('/api/eliminar_historial_digitalizacion', {
                    evento_id: item.eventoId,
                });

                this.msg?.('success', response.data?.message || 'Historial eliminado.');
                this.fetchHistorial();
            } catch (error) {
                const message = error.response?.data?.message || 'No se pudo eliminar el historial.';
                this.msg?.('danger', message);
            }
        },
    },
    mounted() {
        this.search = '';
        const colegiosPromise = this.cargarColegios();
        this.fetchHistorial(colegiosPromise);
    },
    beforeDestroy() {
        this.flushAutoGuardado();
        Object.keys(this.autoSaveTimers).forEach((ocrId) => this.clearAutoSaveTimer(ocrId));
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <!-- Header -->
                    <div class="card-header py-3 d-flex align-items-center justify-content-between"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <div class="d-flex align-items-center">
                            <i class="bx bx-history font-size-24 text-white mr-2"></i>
                            <h5 class="text-white mb-0 font-weight-bold">Historial de Digitalizacion</h5>
                        </div>
                        <b-button variant="light" size="sm" @click="fetchHistorial" :disabled="loading">
                            <b-spinner small v-if="loading" class="mr-1"></b-spinner>
                            <i class="bx bx-refresh mr-1" v-else></i> Actualizar
                        </b-button>
                    </div>

                    <div class="card-body">
                        <!-- Buscador -->
                        <div class="row mb-3 align-items-center">
                            <div class="col-md-6">
                                <b-input-group>
                                    <b-input-group-prepend is-text><i class="bx bx-search-alt"></i></b-input-group-prepend>
                                    <b-form-input v-model="search" placeholder="Buscar por evento, usuario, tipo..." autocomplete="off" clearable />
                                </b-input-group>
                            </div>
                            <div class="col-md-6 d-flex justify-content-end align-items-center">
                                <label class="mr-2 mb-0 text-muted small">Mostrar</label>
                                <b-form-select v-model="perPage" size="sm" :options="pageOptions" style="width:auto;" />
                            </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <small v-if="!historialCompleto" class="text-muted">
                                <span v-if="loadingRestoHistorial">Mostrando los 10 registros más recientes mientras se cargan los demás...</span>
                                <span v-else>Mostrando los 100 registros más recientes. Carga todo el historial para buscar registros anteriores.</span>
                            </small>
                            <small v-else class="text-muted">Historial completo cargado.</small>
                            <b-button size="sm" variant="outline-primary" @click="cambiarModoHistorial" :disabled="loading">
                                {{ historialCompleto ? 'Volver a los últimos 100' : 'Cargar todo el historial' }}
                            </b-button>
                        </div>

                        <!-- Spinner -->
                        <div v-if="loading" class="text-center py-5">
                            <b-spinner variant="primary" style="width:3rem;height:3rem;"></b-spinner>
                            <p class="text-muted mt-3">Cargando historial...</p>
                        </div>

                        <div v-else>
                            <div v-if="filteredData.length === 0" class="text-center py-5">
                                <i class="bx bx-inbox font-size-48 text-muted d-block mb-2"></i>
                                <p class="text-muted">No hay registros de digitalizacion</p>
                            </div>

                            <div v-else>
                                <div class="table-responsive">
                                    <table class="table table-hover mb-0">
                                        <thead class="thead-light">
                                            <tr>
                                                <th>ID</th>
                                                <th>Evento</th>
                                                <th class="text-center">Paginas</th>
                                                <th>Tipo</th>
                                                <th>Estado</th>
                                                <th>Fecha</th>
                                                <th>Usuario</th>
                                                <th class="text-center">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in paginatedData" :key="item.id">
                                                <td class="text-muted small">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
                                                <td>
                                                    <span class="font-weight-medium">{{ item.nombreEvento }}</span><br>
                                                    <small class="text-muted">{{ item.filename }}</small>
                                                </td>
                                                <td class="text-center">
                                                    <b-badge variant="info" pill>{{ item.numeroPaginas }}</b-badge>
                                                </td>
                                                <td><small>{{ item.tipo }}</small></td>
                                                <td>
                                                    <b-badge :variant="estadoVariant(item.estado)" pill class="px-2 py-1">
                                                        {{ item.estado }}
                                                    </b-badge>
                                                    <small class="d-block text-muted mt-1">
                                                        {{ item.fichasVerificadas }}/{{ item.totalFichasVerificacion }} fichas verificadas
                                                    </small>
                                                </td>
                                                <td><small class="text-muted">{{ item.fecha }}</small></td>
                                                <td><small>{{ item.usuario }}</small></td>
                                                <td class="text-center">
                                                    <b-button size="sm" variant="outline-primary" class="mr-1"
                                                        @click="verDetalle(item)" v-b-tooltip.hover title="Ver detalle">
                                                        <i class="bx bx-show-alt"></i>
                                                    </b-button>
                                                    <b-button size="sm" variant="outline-success"
                                                        @click="descargar(item)"
                                                        :disabled="!['completado', 'finalizado'].includes(item.estado)"
                                                        v-b-tooltip.hover title="Descargar">
                                                        <i class="bx bx-download"></i>
                                                    </b-button>
                                                    <b-button v-if="puedeBorrarHistorial" size="sm" variant="outline-danger" class="ml-1"
                                                        @click="eliminarHistorial(item)"
                                                        v-b-tooltip.hover title="Borrar para prueba">
                                                        <i class="bx bx-trash"></i>
                                                    </b-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="row mt-3">
                                    <div class="col d-flex justify-content-end">
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" class="mb-0" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Detalle -->
        <b-modal ref="modal-detalle" size="xl" ok-only ok-title="Cerrar" scrollable v-if="itemSeleccionado" @hide="flushAutoGuardado">
            <template #modal-header>
                <div class="d-flex align-items-center w-100"
                    style="background: linear-gradient(135deg,#252C5F,#61B7E4); margin:-1rem -1rem 0; padding:1rem 1.25rem; border-radius:.3rem .3rem 0 0; width:calc(100% + 2rem) !important;">
                    <i class="bx bx-file-find font-size-24 text-white mr-2"></i>
                    <div>
                        <h5 class="text-white mb-0 font-weight-bold">{{ itemSeleccionado.filename }}</h5>
                        <small class="text-white" style="opacity:.8;">N.º en listado: {{ itemSeleccionadoNumero }}</small>
                    </div>
                    <b-button variant="link" class="ml-auto text-white p-0" @click="$refs['modal-detalle'].hide()">
                        <i class="bx bx-x font-size-22"></i>
                    </b-button>
                </div>
            </template>

            <!-- Alerta de estado -->
            <b-alert :variant="estadoVariant(itemSeleccionado.estado)" show class="d-flex align-items-center mb-3">
                <i class="bx font-size-18 mr-2"
                    :class="['completado', 'finalizado'].includes(itemSeleccionado.estado) ? 'bx-check-circle' : itemSeleccionado.estado === 'procesando' ? 'bx-loader-alt' : itemSeleccionado.estado === 'revision' ? 'bx-error' : 'bx-error-circle'"></i>
                <strong class="mr-auto">
                    {{ itemSeleccionado.estado === 'finalizado' ? 'Archivo finalizado: todas las fichas están verificadas' :
                       itemSeleccionado.estado === 'completado' ? 'Procesamiento completado' :
                       itemSeleccionado.estado === 'procesando' ? 'Procesando documento...' :
                       itemSeleccionado.estado === 'revision' ? 'Documento requiere revision' :
                       itemSeleccionado.estado === 'pendiente' ? 'Documento pendiente de envio' : 'Error en procesamiento' }}
                </strong>
                <b-badge :variant="estadoVariant(itemSeleccionado.estado)">{{ itemSeleccionado.estado }}</b-badge>
            </b-alert>
            <p v-if="itemSeleccionado.error" class="text-danger small mt-1">{{ itemSeleccionado.error }}</p>

            <div class="card border mb-3">
                <div class="card-body py-2 d-flex align-items-center justify-content-between">
                    <span class="font-weight-medium" style="color:#252C5F;">
                        <i class="bx bx-cloud mr-1"></i> Sincronizacion del evento con HubSpot
                    </span>
                    <div class="d-flex align-items-center">
                        <b-button size="sm" variant="outline-primary" class="mr-3 d-inline-flex align-items-center justify-content-center text-center"
                            :disabled="!itemSeleccionado.hubspotEventoSincronizado || syncingHubspotBulk"
                            @click="syncTodosContactosHubspot">
                            <b-spinner small v-if="syncingHubspotBulk" class="mr-1"></b-spinner>
                            <i v-else class="bx bx-cloud-upload mr-1"></i>
                            {{ syncingHubspotBulk ? 'Enviando contactos...' : 'Enviar todos a HubSpot' }}
                        </b-button>
                        <div class="text-right">
                        <b-badge :variant="hubspotVariant(itemSeleccionado.hubspotEventoSincronizado)" pill>
                            {{ itemSeleccionado.hubspotEventoSincronizado ? 'Evento sincronizado' : 'Evento sin sincronizar' }}
                        </b-badge>
                        <small v-if="itemSeleccionado.hubspotActividadId" class="d-block text-muted mt-1">
                            Actividad ID: {{ itemSeleccionado.hubspotActividadId }}
                        </small>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="itemSeleccionado.cargandoDetalle" class="text-center py-5">
                <b-spinner variant="primary" class="mb-3"></b-spinner>
                <p class="text-muted mb-0">Cargando páginas y datos del documento...</p>
            </div>

            <!-- Datos extraidos por pagina -->
            <div v-else-if="itemSeleccionado.datosOCR && itemSeleccionado.datosOCR.items">

                <!-- Total paginas procesadas -->
                <div class="card border mb-4">
                    <div class="card-body py-2 d-flex align-items-center justify-content-between">
                        <span class="font-weight-medium" style="color:#252C5F;">
                            <i class="bx bx-copy-alt mr-1"></i> Total de paginas procesadas
                        </span>
                        <b-badge variant="primary" pill>
                            {{ itemSeleccionado.datosOCR.items.length }}
                            pagina{{ itemSeleccionado.datosOCR.items.length !== 1 ? 's' : '' }}
                        </b-badge>
                    </div>
                </div>

                <!-- Por cada pagina -->
                <div v-for="(ocr, idx) in itemSeleccionado.datosOCR.items" :key="ocr.id || idx" class="card border mb-4">
                    <!-- Cabecera pagina -->
                    <div class="card-header d-flex align-items-center justify-content-between py-2"
                        style="background:#f8f9fa; border-bottom:1px solid #e0e0e0;">
                        <div class="d-flex align-items-center">
                            <i class="bx bx-file-blank font-size-20 mr-2" style="color:#252C5F;"></i>
                            <span class="font-weight-bold" style="color:#252C5F;">
                                Archivo {{ ocr.fileNumber }} - {{ ocr.fileName }} - pagina {{ ocr.pageInFile }}
                            </span>
                            <b-badge :variant="archivoFinalizado(ocr) ? 'success' : 'warning'" pill class="ml-2">
                                {{ archivoFinalizado(ocr) ? 'Archivo finalizado' : 'Archivo pendiente' }}
                            </b-badge>
                        </div>
                        <b-badge :variant="fichaVerificada(ocr) ? 'success' : 'warning'" pill>
                            <i class="bx mr-1" :class="fichaVerificada(ocr) ? 'bx-check' : 'bx-error-circle'"></i>
                            {{ fichaVerificada(ocr) ? 'Verificada' : 'Requiere revisión' }}
                        </b-badge>
                    </div>

                    <div class="card-body p-0">
                        <div class="row no-gutters">
                            <!-- Columna imagen -->
                            <div class="col-md-7 p-3" style="background:#f5f5f5; border-right:1px solid #e0e0e0;">
                                <p class="font-weight-medium mb-2" style="color:#252C5F;">
                                    <i class="bx bx-file mr-1"></i> Archivo enviado
                                </p>
                                <div style="border:2px solid #e0e0e0;border-radius:8px;overflow:hidden;background:white;">
                                    <iframe v-if="ocr.url && itemSeleccionado.tipo === 'PDF'" :src="ocr.url" loading="lazy" style="width:100%;height:600px;border:0;"></iframe>
                                    <img v-else-if="ocr.url" :src="ocr.url" class="img-fluid" style="width:100%;display:block;" />
                                    <div v-else class="text-center text-muted py-5 px-3">
                                        <i class="bx bx-file-blank font-size-36 d-block mb-2"></i>
                                        Sin vista previa disponible
                                    </div>
                                </div>
                                <small class="text-muted d-block text-center mt-2">{{ ocr.requestId ? `Request Alegoria: ${ocr.requestId}` : 'Aun sin request Alegoria' }}</small>
                                <div class="text-center mt-2">
                                    <b-button size="sm" variant="outline-primary"
                                        :disabled="!ocr.requestId || refrescandoResultado[ocr.id]"
                                        @click="refrescarResultado(ocr, idx)">
                                        <b-spinner small v-if="refrescandoResultado[ocr.id]" class="mr-1"></b-spinner>
                                        <i v-else class="bx bx-refresh mr-1"></i>
                                        Consultar resultado
                                    </b-button>
                                </div>
                            </div>

                            <!-- Columna datos -->
                            <div class="col-md-5 p-3">
                                <b-alert v-if="!fichaVerificada(ocr)" variant="warning" show class="small py-2">
                                    <strong>Para verificar esta ficha falta:</strong>
                                    {{ motivosFichaPendiente(ocr).join(', ') }}.
                                </b-alert>
                                <!-- Botones editar -->
                                <div class="d-flex justify-content-between align-items-start flex-wrap mb-3">
                                    <div>
                                        <small v-if="ocr.hubspotSyncStatus === 'error'" class="text-danger d-block" :title="ocr.hubspotSyncError || ''">
                                            <i class="bx bx-error-circle mr-1"></i> Error de sincronizacion; puedes reintentar
                                        </small>
                                        <small v-if="ocr.hubspotSyncStatus === 'error' && ocr.hubspotSyncError" class="text-danger d-block mt-1">
                                            {{ ocr.hubspotSyncError }}
                                        </small>
                                        <small v-else-if="ocr.hubspotSyncStatus !== 'error' && hubspotTieneCambiosPendientes(ocr)" class="text-warning d-block">
                                            <i class="bx bx-time-five mr-1"></i> Hay cambios locales pendientes de enviar
                                        </small>
                                        <small v-else-if="ocr.hubspotSynced" class="text-success d-block">
                                            <i class="bx bx-check-circle mr-1"></i> Sincronizado con HubSpot
                                        </small>
                                        <small v-else class="text-muted d-block">
                                            <i class="bx bx-time-five mr-1"></i> Aun no sincronizado con HubSpot
                                        </small>
                                        <small v-if="ocr.hubspotContactId" class="text-muted d-block">
                                            Contacto ID: {{ ocr.hubspotContactId }}
                                        </small>
                                    </div>
                                    <div class="d-flex align-items-center flex-wrap justify-content-end mt-2 mt-md-0">
                                        <b-button size="sm" :variant="hubspotButtonVariant(ocr)" class="mr-1 mb-1 d-inline-flex align-items-center justify-content-center text-center"
                                            :disabled="!itemSeleccionado.hubspotEventoSincronizado || syncingHubspotContacto[ocr.id]"
                                            @click="syncContactoHubspot(ocr)">
                                            <b-spinner small v-if="syncingHubspotContacto[ocr.id]" class="mr-1"></b-spinner>
                                            <i v-else class="bx mr-1" :class="hubspotTieneCambiosPendientes(ocr) ? 'bx-error-circle' : (ocr.hubspotSynced ? 'bx-refresh' : 'bx-cloud-upload')"></i>
                                            {{ hubspotButtonLabel(ocr) }}
                                        </b-button>
                                        <small v-if="guardandoPagina[ocr.id]" class="text-muted mb-1">Guardando...</small>
                                    </div>
                                </div>

                                <!-- Datos de contacto -->
                                <p class="font-weight-bold mb-2 small" style="color:#252C5F;">
                                    <i class="bx bx-user mr-1"></i> Datos de Contacto
                                </p>
                                <div class="row">
                                    <div class="col-12">
                                        <b-form-group label="Nombres" label-class="small font-weight-medium">
                                            <b-form-input v-model="ocr.fields.nombres" size="sm"
                                                @input="programarAutoGuardado(idx)" />
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <b-form-group label="Apellido paterno" label-class="small font-weight-medium">
                                            <b-form-input v-model="ocr.fields.apellido_paterno" size="sm"
                                                @input="programarAutoGuardado(idx)" />
                                        </b-form-group>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <b-form-group label="Apellido materno" label-class="small font-weight-medium">
                                            <b-form-input v-model="ocr.fields.apellido_materno" size="sm"
                                                @input="programarAutoGuardado(idx)" />
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <b-form-group label="RUT / Pasaporte" label-class="small font-weight-medium">
                                            <b-form-input v-model="ocr.fields.rut" size="sm"
                                                :disabled="ocr.fields.sin_rut"
                                                :placeholder="ocr.fields.sin_rut ? 'Sin RUT' : (ocr.fields.es_pasaporte ? 'Documento alfanumerico' : '')"
                                                @input="onRutInput(ocr); programarAutoGuardado(idx)"
                                                :class="rutInputClass(ocr)" />
                                            <small v-if="!ocr.fields.es_pasaporte && !ocr.fields.sin_rut && !isValidRut(ocr.fields.rut)" class="text-danger d-block mt-1">
                                                Ingresa un RUT valido o marca que es pasaporte.
                                            </small>
                                            <b-form-checkbox v-model="ocr.fields.es_pasaporte" size="sm" class="mt-2"
                                                @change="cambiarEstadoDocumento(ocr, 'es_pasaporte', idx)">
                                                Es pasaporte
                                            </b-form-checkbox>
                                            <b-form-checkbox v-model="ocr.fields.sin_rut" size="sm"
                                                @change="cambiarEstadoDocumento(ocr, 'sin_rut', idx)">
                                                Sin RUT
                                            </b-form-checkbox>
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <b-form-group label="Email" label-class="small font-weight-medium">
                                            <b-form-input v-model="ocr.fields.email" size="sm"
                                                @input="programarAutoGuardado(idx)"
                                                :class="emailInputClass(ocr)" />
                                            <small v-if="!isValidEmail(ocr.fields.email)" class="text-danger d-block mt-1">
                                                Ingresa un correo con formato valido.
                                            </small>
                                        </b-form-group>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <b-form-group label="Telefono" label-class="small font-weight-medium">
                                            <b-form-input v-model="ocr.fields.phone" size="sm"
                                                @input="programarAutoGuardado(idx)" />
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <b-form-group label="Colegio" label-class="small font-weight-medium">
                                            <multiselect
                                                v-model="ocr.colegioSeleccionado"
                                                :options="colegios"
                                                track-by="id"
                                                :custom-label="colegioLabel"
                                                :searchable="true"
                                                :internal-search="true"
                                                :allow-empty="true"
                                                :loading="cargandoColegios"
                                                placeholder="Buscar colegio por nombre o RBD..."
                                                selectLabel="Seleccionar"
                                                selectedLabel="Seleccionado"
                                                deselectLabel="Remover"
                                                @input="seleccionarColegio($event, idx)">
                                                <template v-slot:noOptions>
                                                    <span class="text-muted">No hay colegios disponibles</span>
                                                </template>
                                                <template v-slot:noResult>
                                                    <span class="text-muted">No se encontró coincidencia</span>
                                                </template>
                                            </multiselect>
                                            <b-form-input v-if="!ocr.colegioSeleccionado"
                                                v-model="ocr.fields.colegio"
                                                size="sm"
                                                class="mt-2"
                                                placeholder="Texto del colegio detectado o escrito manualmente"
                                                @input="programarAutoGuardado(idx)" />
                                            <small v-if="ocr.colegioSeleccionado" class="text-muted d-block mt-1">
                                                Se enviará a HubSpot como {{ ocr.colegioSeleccionado.nombre }} (RBD {{ ocr.colegioSeleccionado.rbd }}).
                                            </small>
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <b-form-group label="Curso" label-class="small font-weight-medium">
                                            <b-form-select v-model="ocr.fields.curso" size="sm"
                                                :options="cursoOptionsFor(ocr.fields.curso)"
                                                @change="programarAutoGuardado(idx, true)" />
                                        </b-form-group>
                                    </div>
                                </div>

                                <hr class="my-2" />

                                <!-- Preferencias de Carreras -->
                                <p class="font-weight-bold mb-2 small" style="color:#252C5F;">
                                    <i class="bx bx-book mr-1"></i> Preferencias de Carreras
                                </p>
                                <div class="row">
                                    <div class="col-12">
                                        <b-form-group label="Preferencia 1" label-class="small font-weight-medium">
                                            <b-form-select v-model="ocr.fields.carrera" size="sm"
                                                :options="carreraOptionsFor()"
                                                @change="programarAutoGuardado(idx, true)" />
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <b-form-group label="Preferencia 2" label-class="small font-weight-medium">
                                            <b-form-select v-model="ocr.fields.preferencia_2" size="sm"
                                                :options="carreraOptionsFor()"
                                                @change="programarAutoGuardado(idx, true)" />
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <b-form-group label="Preferencia 3" label-class="small font-weight-medium">
                                            <b-form-select v-model="ocr.fields.preferencia_3" size="sm"
                                                :options="carreraOptionsFor()"
                                                @change="programarAutoGuardado(idx, true)" />
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <b-form-group label="Preferencia extra" label-class="small font-weight-medium">
                                            <b-form-input v-model="ocr.fields.preferencia_extra" size="sm"
                                                @input="programarAutoGuardado(idx)" />
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <b-form-group label="Preferencia extra 2" label-class="small font-weight-medium">
                                            <b-form-input v-model="ocr.fields.preferencia_extra_2" size="sm"
                                                @input="programarAutoGuardado(idx)" />
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <b-form-checkbox v-model="ocr.fields.acepta_terminos" size="sm"
                                            @change="programarAutoGuardado(idx, true)">
                                            Acepto terminos y condiciones
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Informacion del proceso -->
                <div class="card border mt-2">
                    <div class="card-body">
                        <p class="font-weight-bold mb-3 small" style="color:#252C5F;">Informacion del Proceso</p>
                        <div class="d-flex align-items-center mb-2">
                            <i class="bx bx-calendar text-muted mr-2"></i>
                            <span class="text-muted small mr-2">Fecha de procesamiento:</span>
                            <span class="small">{{ itemSeleccionado.fecha }}</span>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <i class="bx bx-user text-muted mr-2"></i>
                            <span class="text-muted small mr-2">Usuario:</span>
                            <span class="small">{{ itemSeleccionado.usuario }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <i class="bx bx-file text-muted mr-2"></i>
                            <span class="text-muted small mr-2">Tipo de archivo:</span>
                            <span class="small">{{ itemSeleccionado.tipo }}</span>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Sin datos OCR -->
            <div v-else-if="itemSeleccionado.detallesCargados" class="text-center py-5">
                <i class="bx font-size-48 d-block mb-3"
                    :class="itemSeleccionado.estado === 'procesando' ? 'bx-loader-alt text-primary' : 'bx-error-circle text-muted'"></i>
                <h6>
                    {{ itemSeleccionado.estado === 'procesando' ? 'Procesando documento...' : 'No hay datos disponibles' }}
                </h6>
                <p class="text-muted small">
                    {{ itemSeleccionado.estado === 'procesando'
                        ? 'Los datos extraidos apareceran aqui cuando el procesamiento finalice.'
                        : 'El documento no pudo ser procesado correctamente.' }}
                </p>
            </div>

        </b-modal>
    </Layout>
</template>

<style scoped>
.table td, .table th { vertical-align: middle; }
</style>
<style>
#modal-detalle___BV_modal_header_ {
    padding: 0 !important;
    border-bottom: none !important;
}
</style>
